angular.module('picmonic-common').component('challengeLeaderboard', {
    templateUrl: '/templates/common/components/challenge-leaderboard/challenge-leaderboard.html',
    bindings: {
        challenge: '<'
    },
    controller: ['UserService', function(UserService){
        var ctrl = this;
        ctrl.UserService = UserService;
    }]
});